import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import OutlinedInput from '../../components/outlinedInput/OutlinedInput'
import Text from '../../components/text/Text'
import { useLoadingContext } from '../../context/spinnerContext'
import { postProductPromotion, postPromotion } from '../../services/promotions'
import './CreateInStorePromotion.css'
import moment from 'moment'

import {
    IOnChangeDataPromotionOnline,
    SectionsEnum,
    SectionsKeyEnum,
} from '../../components/promotions/marketplace/PromotionMarketplaceComponent'
interface PromotionState {
    promoName?: string
    discount?: string
    minAmount?: string
    online?: IOnChangeDataPromotionOnline
}

const codeErrors = ['-1', '-2', '-3', '-4']

const errors: { [key: string]: string } = {
    '0': 'Error: Ocurrió un error al crear una promoción.',
    '-1': 'Ya posee una promoción presencial vigente.',
    '-2': 'Ya posee una promoción online de tipo DescuentoDelivery vigente.',
    '-3': 'Ya posee una promoción online de tipo DescuentoMedioPago vigente.',
    '-4': 'Ya posee una promoción online de tipo DescuentoSKU vigente.',
}

const CreateInStorePromotion: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state as PromotionState
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const loadingContext = useLoadingContext()
    const [startDate, setStartDate] = useState<string>('')
    const [endDate, setEndDate] = useState('')
    const selectedLocalId = localStorage.getItem('selectedLocalId')

    function parseFormatDateMac(_date: string) {
        const [day, month, year] = _date.split('/')
        return `${year}-${month}-${day}`
    }

    const handleCreatePresentialPromotion = async () => {
        if (!validateCurrentDate(startDate)) {
            alert('La fecha de inicio debe ser mayor a la actual')
            return
        }

        if (!validateDateIsAfterStartDate(endDate, startDate)) {
            return
        }

        if (state.online?.selected && state.online.valid) {
            const days = {
                bLunes: state.online?.days.includes('LUN'),
                bMartes: state.online?.days.includes('MAR'),
                bMiercoles: state.online?.days.includes('MIER'),
                bJueves: state.online?.days.includes('JUE'),
                bViernes: state.online?.days.includes('VIE'),
                bSabado: state.online?.days.includes('SAB'),
                bDomingo: state.online?.days.includes('DOM'),
            }

            const dataPromotion = {
                sPromocion: state.promoName,
                sTipo:
                    state.online.selected === SectionsEnum.deliveryFree
                        ? SectionsKeyEnum.deliveryFree
                        : state.online.selected === SectionsEnum.specificProduct
                        ? SectionsKeyEnum.specificProduct
                        : state.online.selected === SectionsEnum.percentage
                        ? SectionsKeyEnum.percentage
                        : SectionsKeyEnum.percentage,
                nDescuento: state.online.percentage,
                nMontoMinimo: state.online.amount,
                bTiendaPresencial: false,
                bTiendaOnline: true,
                sEstado: 'vigente',
                dInicio: startDate,
                dTermino: endDate,
                bLunes: state.online.check ? true : days.bLunes,
                bMartes: state.online.check ? true : days.bMartes,
                bMiercoles: state.online.check ? true : days.bMiercoles,
                bJueves: state.online.check ? true : days.bJueves,
                bViernes: state.online.check ? true : days.bViernes,
                bSabado: state.online.check ? true : days.bSabado,
                bDomingo: state.online.check ? true : days.bDomingo,
                tInicio: state.online.check
                    ? '00:00'
                    : state.online.startTime || '00:00',
                tTermino: state.online.check
                    ? '23:59'
                    : state.online.endTime || '23:59',
            }

            loadingContext?.onOpen()
            try {
                if (!selectedLocalId)
                    throw new Error('No se ha seleccionado un local')
                await postPromotion(selectedLocalId, dataPromotion).then(
                    async (resp: any) => {
                        loadingContext?.onClose()
                        if (
                            resp.idPromocion &&
                            String(resp.idPromocion).trim() === '0'
                        ) {
                            const mensaje = codeErrors.includes(resp.sMensaje)
                                ? resp.sMensaje
                                : '0'

                            alert(errors[mensaje] || 'Error')
                        } else {
                            if (
                                state.online?.selected ===
                                SectionsEnum.specificProduct
                            ) {
                                loadingContext?.onOpen()
                                const dataPromotion = {
                                    discount: state.online?.percentage,
                                    sku: state.online?.product?.value.sku,
                                    promotionID: resp.idPromocion,
                                    dateVoidPromotion:
                                        parseFormatDateMac(endDate),
                                    startDate: parseFormatDateMac(startDate),
                                    stock: Number(state.online.stock) || 0,
                                }
                                await postProductPromotion(dataPromotion).then(
                                    () => {
                                        loadingContext?.onClose()
                                        navigate('PromotionCreated', {
                                            state: {
                                                idPromocion: resp.idPromocion,
                                            },
                                        })
                                    }
                                )
                            } else {
                                navigate('PromotionCreated', {
                                    state: {
                                        idPromocion: resp.idPromocion,
                                    },
                                })
                            }
                        }
                    }
                )
            } catch (err) {
                alert('Error: Ocurrió un error al crear una promoción.')
            } finally {
                loadingContext?.onClose()
            }
        } else {
            const dataPromotion = {
                sPromocion: state.promoName,
                sTipo: 'DescuentoMedioPago',
                nDescuento: state.discount,
                nMontoMinimo: state.minAmount,
                bTiendaPresencial: true,
                bTiendaOnline: false,
                sEstado: 'vigente',
                dInicio: startDate,
                dTermino: endDate,
                bLunes: true,
                bMartes: true,
                bMiercoles: true,
                bJueves: true,
                bViernes: true,
                bSabado: true,
                bDomingo: true,
                tInicio: '00:00',
                tTermino: '23:59',
            }
            loadingContext?.onOpen()
            try {
                if (!selectedLocalId)
                    throw new Error('No se ha seleccionado un local')
                await postPromotion(selectedLocalId, dataPromotion).then(
                    (resp: any) => {
                        if (
                            resp &&
                            resp.idPromocion &&
                            String(resp.idPromocion).trim() === '0'
                        ) {
                            const mensaje = codeErrors.includes(resp.sMensaje)
                                ? resp.sMensaje
                                : '0'

                            alert(errors[mensaje] || 'Error')
                        } else {
                            loadingContext?.onClose()
                            navigate('PromotionCreated', {
                                state: {
                                    idPromocion: resp.idPromocion,
                                },
                            })
                            console.log(resp, 'se creo la promocion')
                        }
                    }
                )
            } catch (err) {
                console.log('Error', 'Ocurrió un error al crear una promoción.')
            } finally {
                loadingContext?.onClose()
            }
        }
    }

    const validateCreatedPromotion = () => {
        if (!validateDateIsAfterStartDate(endDate, startDate, false)) {
            return false
        }

        const hasPromoOnline = !!state.online
        return (
            state.promoName &&
            state.promoName.trim() !== '' &&
            startDate &&
            startDate.trim() !== '' &&
            endDate &&
            endDate.trim() !== '' &&
            (!hasPromoOnline ||
                (!!state.online &&
                    state.online?.selected &&
                    state.online.valid) ||
                (state.discount &&
                    state.discount.trim() !== '' &&
                    state.minAmount &&
                    state.minAmount.trim() !== ''))
        )
    }

    const validateDateIsTodayOrLater = (inputValue: string): boolean => {
        const isValidDate = moment(inputValue, 'DD/MM/YYYY', true).isValid()

        if (!isValidDate) {
            alert('Fecha no válida. Use el formato dd/mm/aaaa.')
            return false
        }

        const inputDate = moment(inputValue, 'DD/MM/YYYY')
        const today = moment().startOf('day')

        if (inputDate.isBefore(today)) {
            alert(
                'La fecha ingresada debe ser mayor o igual a la fecha actual.'
            )
            return false
        }

        return true
    }

    const validateDateIsAfterStartDate = (
        inputValue: string,
        startDate: string,
        showAlert = true
    ): boolean => {
        const isValidDate = moment(inputValue, 'DD/MM/YYYY', true).isValid()

        if (!isValidDate) {
            if (showAlert) alert('Fecha no válida. Use el formato dd/mm/aaaa.')
            return false
        }

        const endTime = moment(inputValue, 'DD/MM/YYYY')
        const startMoment = moment(startDate, 'DD/MM/YYYY')
        if (endTime.isBefore(startMoment)) {
            if (showAlert)
                alert(
                    'La fecha de término debe ser mayor o igual a la fecha de inicio.'
                )
            return false
        }

        const differenceInDays = endTime.diff(startMoment, 'days')
        // Verifica si la diferencia es como máximo de 30 días
        if (differenceInDays > 30) {
            if (showAlert)
                alert(
                    'La fecha de término debe ser menor o igual a 30 días después de la fecha de inicio.'
                )
            return false
        }

        return true
    }

    const validateCurrentDate = (date_: string): boolean => {
        const split_ = date_.split('/')
        const day = parseInt(split_[0], 10)
        const month = parseInt(split_[1], 10) - 1
        const year = parseInt(split_[2], 10)
        const d = new Date(year, month, day)
        const current = new Date()
        return d >= current
    }

    const handleDateChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        setter: (value: string) => void,
        startDate?: string
    ) => {
        const inputValue = e.currentTarget.value
        const numericValue = inputValue.replace(/\D/g, '')

        let formattedValue = ''
        if (numericValue.length <= 2) {
            formattedValue = numericValue
        } else if (numericValue.length <= 4) {
            formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(
                2
            )}`
        } else {
            formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(
                2,
                4
            )}/${numericValue.slice(4, 8)}`
        }

        if (numericValue.length === 8) {
            if (!startDate && !validateDateIsTodayOrLater(formattedValue)) {
                return
            }
            if (
                startDate &&
                !validateDateIsAfterStartDate(formattedValue, startDate)
            ) {
                return
            }
        }

        setter(formattedValue)
    }

    const renderPromotionValidationInfo = () => {
        return (
            <div className="background-create-promotion">
                <Text
                    variant="promotion-page-title"
                    label="Crear promoción"
                    fontSize={27}
                    fontWeight={400}
                    color={'#184287'}
                />
                <div className="card-promotion-container">
                    <div className="flex-direction-promotion">
                        <div>
                            <Text
                                label="1"
                                fontSize={16}
                                fontWeight={600}
                                color="#184287"
                                textAlign="center"
                            />
                            <Text
                                label="Información de promoción"
                                fontSize={16}
                                fontWeight={600}
                                color="#184287"
                            />
                        </div>
                        <div className="line-promotion" />
                        <div>
                            <Text
                                label="2"
                                fontSize={16}
                                fontWeight={600}
                                color="#184287"
                                textAlign="center"
                            />
                            <Text
                                label="Asignación de vigencia"
                                fontSize={16}
                                fontWeight={600}
                                color="#184287"
                            />
                        </div>
                    </div>
                    <Text
                        label="Vigencia de la promoción"
                        fontSize={20}
                        fontWeight={600}
                        color={'#565656'}
                        textAlign={'center'}
                        marginTop={5}
                        marginBottom={10}
                    />
                    <Text
                        label={`⚠️ Recuerda, la fecha de término debe ser menor\no igual a 30 días a partir de la fecha actual`}
                        fontSize={16}
                        fontWeight={400}
                        color={'#565656'}
                        textAlign={'center'}
                        lineHeight={'1'}
                        marginBottom={5}
                    />
                    <div className="flex-Direction-create-promotion">
                        <Text
                            label="Fecha de inicio"
                            fontSize={16}
                            fontWeight={600}
                            color="#565656"
                        />
                        <div>
                            <OutlinedInput
                                placeholder="29/08/2024"
                                charCounter={true}
                                fieldWrapperStyle={{
                                    borderColor: '#BBBBBB',
                                    height: 38,
                                    width: 196,
                                }}
                                inputStyle={{
                                    textAlign: 'end',
                                    marginRight: 10,
                                    fontFamily: 'Nunito',
                                }}
                                value={startDate}
                                onChange={(e) =>
                                    handleDateChange(e, setStartDate)
                                }
                            />
                        </div>
                    </div>
                    <div className="flex-Direction-create-promotion">
                        <Text
                            label="Fecha de término"
                            fontSize={16}
                            fontWeight={600}
                            color="#565656"
                        />
                        <div>
                            <OutlinedInput
                                placeholder="01/03/2025"
                                charCounter={true}
                                fieldWrapperStyle={{
                                    borderColor: '#BBBBBB',
                                    height: 38,
                                    width: 196,
                                }}
                                inputStyle={{
                                    textAlign: 'end',
                                    marginRight: 10,
                                    fontFamily: 'Nunito',
                                }}
                                value={endDate}
                                onChange={(e) =>
                                    handleDateChange(e, setEndDate, startDate)
                                }
                            />
                        </div>
                    </div>
                    <div
                        onClick={
                            validateCreatedPromotion()
                                ? handleCreatePresentialPromotion
                                : undefined
                        }
                        className={
                            validateCreatedPromotion()
                                ? 'create-promotion-button'
                                : 'create-promotion-button-disabled'
                        }
                    >
                        <Text
                            label="Crear promoción"
                            fontSize={16}
                            fontWeight={600}
                            color="white"
                        />
                    </div>
                </div>
            </div>
        )
    }
    return <div>{renderPromotionValidationInfo()}</div>
}

export default CreateInStorePromotion
